import { render, staticRenderFns } from "./UtilityDetailManager.vue?vue&type=template&id=2d27c786&scoped=true&"
import script from "./UtilityDetailManager.vue?vue&type=script&lang=js&"
export * from "./UtilityDetailManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d27c786",
  null
  
)

export default component.exports